import request from '@/utils/request'

// 获取定价方式审批主表信息
export function pmPriceModeCreateHead(pmCreateHeadId) {
  return request({
    url: `/api/srm-slcm/pmPriceModeApply/getPriceModeApplyById/${pmCreateHeadId}`,
    method: 'get'
  })
}
